module.exports = __webpack_public_path__ + "media/images/icons/copy_link-9f5dedf0ddc9dad4b373d4f32085497c.svg";